var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ckeditor", {
    attrs: { editor: _vm.editor, config: _vm.config },
    model: {
      value: _vm.data,
      callback: function ($$v) {
        _vm.data = $$v
      },
      expression: "data",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }